export const pdfCVUrl = "../assets/JAYVEE_ANN U. SORIANO_CV.pdf";
export const pdfCVFilename = "JAYVEE_ANN U. SORIANO_CV.pdf";
export const githubLink = "https://github.com/jayveeannsoriano";
export const linkedInProfile = "https://www.linkedin.com/in/jayvee-ann-soriano-18494a1a4/";
export const facebookProfile = "https://www.facebook.com/jvannsoriano/";
export const bitbucketProfile = "https://bitbucket.org/jayveesoriano/workspace/overview/";
export const emailAddress = "mailto:sjayveeannsoriano@gmail.com";
export const resumeLink = "https://flowcv.com/resume/fts5ochu2r";